<template>
  <div>
    <van-empty image="error" description="无访问权限" />
    <div style="text-align: center;">
      <van-button type="info" @click="back">{{ text }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: null,
      btntext: 3,
      text: '返回首页（3s）',
    }
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },
  },
  created() {
    this.intervalBack()
  },
  methods: {
    back() {
      if (this.personType == 13) {
        this.$router.replace('/approval')
      } else {
        this.$router.replace('/visitor')
      }
    },
    intervalBack() {
      this.timer = setInterval(() => {
        if (this.btntext == 0) {
          clearInterval(this.timer)
          this.back()
          return
        }
        this.btntext--
        this.text = `返回首页（${this.btntext}s）`
      }, 1000)
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped></style>
